<div class="d-flex align-items-center justify-content-between w-100 gap-3 ci-order-info">
	<div class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
		<div class="d-flex align-items-center gap-3 overflow-hidden min-w-0 ci-order-info__identity">
			<button
				type="button"
				class="d-inline-flex align-items-center gap-2 border-0 bg-transparent px-3 py-1 ci-order-info__address"
				(click)="returnBackClicked()"
			>
				<i class="fa-regular fa-arrow-left flex-shrink-0"></i>
				<span class="text-truncate ci-order-info__address-text">{{ orderInboxModel.description }}</span>
			</button>

			<ng-container *ngIf="orderInboxModel.formType">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">{{ orderInboxModel.formType }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.externalProductName">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">{{ orderInboxModel.externalProductName }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.externalId">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">Ref: #{{ orderInboxModel.externalId }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.externalLoanType">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">{{ orderInboxModel.externalLoanType }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.externalLoanNumber">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">Loan: #{{ orderInboxModel.externalLoanNumber }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.docFileIdUCDP">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">UCDP: #{{ orderInboxModel.docFileIdUCDP }}</span>
			</ng-container>

			<ng-container *ngIf="orderInboxModel.docFileIdEAD">
				<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
				<span class="text-nowrap ci-order-info__meta">EAD: #{{ orderInboxModel.docFileIdEAD }}</span>
			</ng-container>
		</div>

		<span class="d-none flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
		<div #moreMenu class="d-none position-relative flex-shrink-0 ci-order-info__more">
			<button
				type="button"
				class="btn btn-sm d-inline-flex align-items-center justify-content-center border bg-white px-2 ci-order-info__more-btn"
				(click)="op.toggle($event)"
			>
				<i class="fa-regular fa-ellipsis"></i>
			</button>
			<p-overlayPanel #op [appendTo]="moreMenu" styleClass="ci-order-info-overlay">
				<ng-template pTemplate> Content </ng-template>
			</p-overlayPanel>
		</div>

		<ng-container *ngIf="orderUsers.length">
			<span class="flex-shrink-0 align-self-center border-start ci-order-info__separator"></span>
			<cv-users-info [orderUsers]="orderUsers"></cv-users-info>
		</ng-container>
	</div>

	<div class="d-flex align-items-center justify-content-end flex-shrink-0 gap-3 ci-order-info__status">
		<div class="d-flex align-items-center gap-1" *ngIf="showStatusIcons">
			<span
				*ngIf="guaranteeStatusMap[orderInboxModel.guaranteeState ?? 0] as status"
				class="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ci-order-info__status-icon"
				[ngClass]="status.colorClass"
				tooltipStyleClass="custom-tooltip ci-order-info-tooltip"
				tooltipPosition="top"
				appendTo="body"
				[pTooltip]="
					orderInboxModel.guaranteeStateDescription ? 'CVUE ' + orderInboxModel.guaranteeStateDescription : ''
				"
			>
				<i class="fa-regular" [ngClass]="status.icon"></i>
			</span>
			<button
				type="button"
				*ngFor="let item of statusPipelineButtons; trackBy: trackPipelineButton"
				class="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 border-0 p-0 ci-order-info__status-icon"
				[ngClass]="item.style.colorClass"
				[attr.aria-label]="item.style.tooltip"
				tooltipStyleClass="custom-tooltip ci-order-info-tooltip"
				tooltipPosition="top"
				appendTo="body"
				[pTooltip]="item.style.tooltip"
				(click)="handlePipelineClick(item.indicator)"
			>
				<i class="fa-regular" [ngClass]="item.style.icon"></i>
			</button>
		</div>

		<span
			class="d-inline-flex align-items-center text-nowrap ci-order-info__badge"
			*ngIf="(orderInboxModel.cuScore ?? 0) > 0"
			>CU {{ orderInboxModel.cuScore }}</span
		>
		<span
			class="d-inline-flex align-items-center text-nowrap ci-order-info__badge"
			*ngIf="(orderInboxModel.lcaScore ?? 0) > 0"
			>LCA {{ orderInboxModel.lcaScore }}</span
		>
	</div>
</div>
